import React from "react";

const TitleProgressBar = ({ percentage, title, color }) => {
  return (
    <div className="w-full flex flex-col items-center justify-center h-[100px]">
      <div className="w-full text-gray-700 text-[12px] sm:text-[14px]">{title}</div>
      <div className="w-full flex flex-row gap-2 items-center justify-center">
        <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden relative">
          <div
            className="skeleton h-full rounded-full transition-all duration-300"
            style={{
              width: `${percentage}%`,
              backgroundColor: color,
            }}
          ></div>
        </div>
        <div className="text-gray-700 text-[12px] sm:text-[14px]">{percentage}%</div>
      </div>
    </div>
  );
};

export default TitleProgressBar;
